import { useEffect, useRef } from "react";
import "./Services.css";

import {
  Megaphone,
  Search,
  Palette,
  LayoutTemplate,
  LineChart,
  Target,
} from "lucide-react";

export default function Services() {
  const sectionRef = useRef(null);

  const list = [
    {
      t: "Meta & TikTok Ads",
      d: "High-converting campaigns with creative testing.",
      Icon: Megaphone,
    },
    {
      t: "Google Ads & SEO",
      d: "Search visibility + leads from high intent users.",
      Icon: Search,
    },
    {
      t: "Content & Design",
      d: "Reels, posters, brand kits, and consistent visuals.",
      Icon: Palette,
    },
    {
      t: "Landing Pages",
      d: "Fast, clean pages built to convert visitors to leads.",
      Icon: LayoutTemplate,
    },
    {
      t: "Analytics & Reporting",
      d: "Weekly performance reports and next actions.",
      Icon: LineChart,
    },
    {
      t: "Brand Strategy",
      d: "Positioning, messaging, and content plan for growth.",
      Icon: Target,
    },
  ];

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    io.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  return (
    <section id="services" className="section services" ref={sectionRef}>
      <div className="container">
        <span className="kicker reveal" style={{ "--d": "0ms" }}>
          What we do
        </span>

        <h2 className="h2 reveal" style={{ "--d": "90ms" }}>
          Services built for growth
        </h2>

        <p className="p reveal" style={{ "--d": "180ms" }}>
          Trending approach: short-form content + performance ads + strong landing pages.
        </p>

        <div className="services__grid mt24">
          {list.map((x, i) => (
            <div
              className="services__card card reveal"
              style={{ "--d": `${240 + i * 90}ms` }}
              key={x.t}
            >
              <div className="services__icon" aria-hidden="true">
                <x.Icon className="services__iconSvg" />
              </div>

              <h3 className="services__title">{x.t}</h3>
              <p className="services__desc">{x.d}</p>
              <div className="services__line" />
              <span className="badge">Result focused</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
